const stars = document.querySelectorAll('.cm-star'); // Opdateret til .cm-star
const ratingStep = document.getElementById('rating-step');
const feedbackForm = document.getElementById('feedback-form');
const redirectMsg = document.getElementById('redirect-message');
let selectedRating = 0;

// NY FUNKTION: Styrer ordrenummer-feltet i realtid
function validateOrder(input) {
  if (!input.value.startsWith('#')) {
    input.value = '#' + input.value.replace(/#/g, '');
  }
  const hash = input.value.charAt(0);
  const numbers = input.value.substring(1).replace(/[^0-9]/g, '');
  input.value = hash + numbers;
}

// Styrer hover- og klik-logik for stjernerne
stars.forEach(star => {
  star.addEventListener('mouseover', function() {
    const currentVal = this.getAttribute('data-value');
    highlightStars(currentVal);
  });

  star.addEventListener('mouseout', function() {
    highlightStars(selectedRating);
  });

  star.addEventListener('click', function() {
    selectedRating = parseInt(this.getAttribute('data-value'));
    highlightStars(selectedRating);
    
    setTimeout(() => {
      if (selectedRating >= 4) {
        ratingStep.style.display = 'none';
        redirectMsg.style.display = 'block';
        window.location.href = "https://dk.trustpilot.com/evaluate/suitclub.dk";
      } else {
        ratingStep.style.display = 'none';
        feedbackForm.style.display = 'block';
      }
    }, 300);
  });
});

function goBackToStars() {
  selectedRating = 0;
  highlightStars(0);
  feedbackForm.style.display = 'none';
  ratingStep.style.display = 'block';
}

function highlightStars(val) {
  stars.forEach(s => {
    if (parseInt(s.getAttribute('data-value')) <= val) {
      s.classList.add('hovered');
    } else {
      s.classList.remove('hovered');
    }
  });
}

// SENDER DATA TIL ZAPIER (Med e-mail validering)
async function submitInternalFeedback() {
  const zapierUrl = "https://hooks.zapier.com/hooks/catch/13749453/u0gfjj2/";
  const submitBtn = document.querySelector('.cm-btn'); // Opdateret til .cm-btn

  const nameValue = document.getElementById('feedback-name').value;
  const emailValue = document.getElementById('feedback-email').value;
  const orderValue = document.getElementById('feedback-order').value;
  const messageValue = document.getElementById('feedback-text').value;

  if (!nameValue || !emailValue || !messageValue) {
    alert("Udfyld venligst både navn, e-mail og besked.");
    return;
  }

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(emailValue)) {
    alert("Indtast venligst en gyldig e-mailadresse.");
    return;
  }

  submitBtn.innerText = "Sender...";
  submitBtn.disabled = true;

  try {
    await fetch(zapierUrl, {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify({
        rating: selectedRating,
        name: nameValue,
        email: emailValue,
        order_number: orderValue,
        message: messageValue,
        domain: "suitclub.dk",
        submitted_at: new Date().toLocaleString()
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    });

    feedbackForm.innerHTML = `
      <div style="padding: 20px; text-align: center;">
        <h3>Tak for din feedback, ${nameValue}!</h3>
        <p>Vi har modtaget din feedback vedrørende ordre ${orderValue}. Vi tager alt feedback til os som en del af vores forbedringsproces, og vi kontakter dig direkte, hvis dit input giver anledning til opfølgende spørgsmål.</p>
      </div>
    `;

  } catch (error) {
    console.error('Zapier Error:', error);
    alert("Der opstod en fejl. Prøv venligst igen senere.");
    submitBtn.innerText = "Send feedback";
    submitBtn.disabled = false;
  }
}